import {
  useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  CheckCircleOutlined,
  DatabaseOutlined,
  ToolOutlined,
  SafetyOutlined,
  BarChartOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <DatabaseOutlined />,
  1: <ToolOutlined />,
  2: <SafetyOutlined />,
  3: <BarChartOutlined />,
};

const HighlightsSection = () => {
  const { t } = useTranslation("eam");

  const items = useMemo(() => {
    const raw = t("highlights.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  const statValue = t("highlights.stat_value");
  const statLabel = t("highlights.stat_label");
  const statDesc = t("highlights.stat_desc");
  const statSecondaryValue = t("highlights.stat_secondary_value");
  const statSecondaryLabel = t("highlights.stat_secondary_label");

  return (
    <section className="dev-eam-section dev-eam-highlights-section">
      <div className="dev-eam-section-inner">
        <h2 className="dev-section-h2 dev-eam-section-h2">
          <span className="dev-eam-section-h2-icon dev-eam-section-h2-icon--cyan" aria-hidden>
            <AppstoreOutlined />
          </span>
          <span>{t("highlights.title")}</span>
        </h2>

        <div className="dev-eam-highlights-grid">
          <div className="dev-eam-highlight-list">
            {items.map((item, idx) => (
              <div key={idx} className="dev-eam-highlight-item">
                <div className="dev-eam-highlight-icon">
                  {iconByIndex[idx] ?? <CheckCircleOutlined />}
                </div>
                <div>
                  <div className="dev-eam-highlight-title">{item.title}</div>
                  <div className="dev-eam-highlight-desc">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="dev-eam-stat-card dev-eam-stat-card--dual">
            <div className="dev-eam-stat-dual-grid">
              <div className="dev-eam-stat-dual-item">
                <div className="dev-eam-stat-value">{statValue}</div>
                <div className="dev-eam-stat-label">{statLabel}</div>
              </div>
              <div className="dev-eam-stat-dual-divider" aria-hidden />
              <div className="dev-eam-stat-dual-item">
                <div className="dev-eam-stat-value dev-eam-stat-value--secondary">{statSecondaryValue}</div>
                <div className="dev-eam-stat-label">{statSecondaryLabel}</div>
              </div>
            </div>
            <div className="dev-eam-stat-desc">{statDesc}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HighlightsSection;
